var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00001 17.2491C6.00001 16.8344 6.3358 16.4982 6.75001 16.4982H17.25C17.6642 16.4982 18 16.8344 18 17.2491C18 17.6638 17.6642 18 17.25 18H6.75001C6.3358 18 6.00001 17.6638 6.00001 17.2491Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0713 1.61007C14.9234 1.46391 14.685 1.46605 14.5397 1.61483L2.36238 14.0652L1.77144 16.3135L4.13408 15.9114L16.3649 3.43362C16.5092 3.28585 16.5071 3.04911 16.3602 2.90393L15.0713 1.61007ZM13.4671 0.565015C14.1934 -0.178927 15.3855 -0.189608 16.125 0.541198L17.4139 1.83506C18.1484 2.56093 18.159 3.74464 17.4375 4.48351L5.0363 17.1357C4.92558 17.2491 4.78185 17.3245 4.62571 17.3511L0.875709 17.9894C0.624437 18.0321 0.368668 17.9442 0.196632 17.7559C0.0245964 17.5676 -0.0401579 17.3048 0.0247066 17.058L0.962207 13.4911C0.995266 13.3653 1.06039 13.2503 1.15119 13.1573L13.4671 0.565015Z",
    fill: "#777777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3107 1.91972L16.0607 5.6743L15 6.73626L11.25 2.98168L12.3107 1.91972Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.74bf00ebfe780d184764634f1f62c44d.svg";
export { ForwardRef as ReactComponent };